import { Button, Card, Col, ConfigProvider, message, Row, Table, Tooltip } from "antd";
import DocumentUploadModal from "./components/modals/DocumentUploadModal";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useAppContext } from "../../hooks/useAppContext";
import DocumentDeactivationModal from "./components/modals/DocumentDeactivationModal";
import DocReplaceModal from "./components/modals/DocReplaceModal";
import { BackBtn } from "../../components/commonComponents";

export default function DocumentPage() {
    const [open, setOpen] = useState(false)

    const [messageApi, contextHolder] = message.useMessage()

    const [departments, setDepartments] = useState([])
    const [hierarchies, setHierarchies] = useState([])

    const [docToEdit, setDocToEdit] = useState(null)
    const [docReplaceModalOpen, setDocReplaceModalOpen] = useState(false)
    const [docEditModalOpen, setDocEditModalOpen] = useState(false)
    const [docDeactivateModalOpen, setDocDeactivateModalOpen] = useState(false)

    const { filterParams, setFilterParams, docs, refreshMenu, menu } = useAppContext()
    const { page, limit } = filterParams

    useEffect(() => {
        if (menu) {
            setDepartments(menu?.department?.map(item => ({
                label: item.code + ' - ' + item.name,
                value: item.code
            })))
            setHierarchies(menu?.structure?.map(item => ({
                label: item.code + ' - ' + item.name,
                value: item.code
            })))
        }
    }, [menu])

    const handleEdit = (doc) => {
        setDocToEdit(doc)
        setDocEditModalOpen(true)
    }

    const handleDeactivate = (doc) => {
        setDocToEdit(doc)
        setDocDeactivateModalOpen(true)
    }

    const handleReplace = (doc) => {
        setDocToEdit(doc)
        setDocReplaceModalOpen(true)
    }

    const columns = [
        {
            title: 'ნომერი',
            dataIndex: 'number',
            key: 'number',
            sorter: (a, b) => a.number - b.number,
            render: (n, d) => (
                <div style={{ textAlign: 'left' }}>{d.department + '-' + d.hierarchy + '-' + d.number+(d?.number_suffix ? d?.number_suffix : '')}</div>
            )
        },
        {
            title: 'დასახელება',
            dataIndex: 'name',
            key: 'name',
            render: (n, d) => (
                <div style={{ textAlign: 'left' }}>{d.name}</div>
            )
        },
        {
            title: 'გამოიცა',
            dataIndex: 'issue_date',
            key: 'issue_date',
            render: (n, d) => (
                <div style={{ textAlign: 'left' }}>{dayjs(d.issue_date).format('DD/MM/YYYY')}</div>
            )
        },
        {
            title: 'აიტვირთა',
            dataIndex: 'uploaded_date',
            key: 'uploaded_date',
            sorter: (a, b) => a.upload_date - b.upload_date,
            render: (n, d) => (
                <div style={{ textAlign: 'left' }}>{dayjs(d.upload_date).format('DD/MM/YYYY')}</div>
            )
        },
        {
            title: 'აღწერა',
            dataIndex: 'comment',
            key: 'comment',
            render: (n, d) => (
                <div style={{ textAlign: 'left' }}>{d.comment}</div>
            )
        },
        {
            title: 'სტატუსი',
            dataIndex: 'is_active',
            key: 'is_active',
            sorter: (a, b) => a.is_active - b.is_active,
            render: (n, d) => (
                <div style={{ textAlign: 'left' }}>{d.is_active ? 'აქტიური' : 'გაუქმებული'}</div>
            )
        },
        {
            title: 'გაუქმების თარიღი',
            key: 'deactivation_date',
            dataIndex: 'deactivation_date',
            render: (n, d) => (
                n && dayjs(n).format('DD.MM.YYYY')
            )
        },
        {
            title: 'გაუქმების მიზეზი',
            key: 'deactivation_comment',
            dataIndex: 'deactivation_comment',
        },
        {
            title: 'მოქმედება',
            key: 'action',
            dataIndex: 'id',
            render: (n, d) => (
                <div style={{ textAlign: 'left', display: 'flex', gap: 10 }}>
                    <ConfigProvider theme={{
                        components: {
                            Button: {
                                colorText: '#85a5ff',
                                colorPrimary: '#2f54eb',
                                colorPrimaryHover: '#1d39c4',
                            },
                        },
                    }}>
                        <Tooltip title="დოკუმენტის რედაქტირება" mouseEnterDelay={0.5} color="#2f54eb">
                            <Button type='primary' icon={<i className="fa-solid fa-file-pen" style={{ color: 'white', fontSize: 18, }}></i>} onClick={() => { handleEdit(d) }} style={{ borderRadius: '30%' }} />
                        </Tooltip>
                    </ConfigProvider>
                    {/* <Upload
                                action={`http://localhost:3000/api/v1/documents/${d.id}/upload`}
                                method="POST"
                                headers={{
                                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                                    }}
                                    > */}
                    <ConfigProvider theme={{
                        components: {
                            Button: {
                                colorText: '#9254de',
                                colorPrimary: '#9254de',
                                colorPrimaryHover: '#733fc8',
                            },
                        },
                    }}>
                        <Tooltip title="დოკუმენტის ატვირთვა" mouseEnterDelay={0.5} color="#9254de">
                            <Button type='primary' onClick={() => { handleReplace(d) }} icon={<i className="fa-solid fa-file-arrow-up" style={{ color: 'white', fontSize: 18, }}></i>} style={{ borderRadius: '30%' }} />
                        </Tooltip>
                    </ConfigProvider>
                    {/* </Upload> */}
                    {
                        d.is_active &&
                        <ConfigProvider theme={{
                            components: {
                                Button: {
                                    colorText: '#eb2f96',
                                    colorPrimary: '#eb2f96',
                                    colorPrimaryHover: '#b42471',
                                },
                            },
                        }}>
                            <Tooltip title="დოკუმენტის დეაქტივაცია" mouseEnterDelay={0.5} color="#eb2f96">
                                <Button type='primary' icon={<i className="fa-solid fa-ban" style={{ color: 'white', fontSize: 18, }}></i>} onClick={() => { handleDeactivate(d) }} style={{ borderRadius: '30%' }} />
                            </Tooltip>
                        </ConfigProvider>
                    }
                </div>
            )
        },
    ]
    return (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'start', flexDirection: 'column'}}>
            <div>
                <BackBtn path='/admin' label='დაბრუნება' />
            </div>
            <Card
                style={{ width: '100%',boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}
                title='დოკუმენტები'
        >
            {contextHolder}
            <Row gutter={[10, 10]}>
                <Col span={24}>
                    <ConfigProvider theme={{
                        components: {
                            Button: {
                                colorPrimary: '#13c2c2',
                                colorPrimaryHover: '#18a2a2',
                            },
                        },
                    }}>
                        <Button type='primary' icon={<i className="fa-solid fa-plus"></i>} onClick={() => { setOpen(true) }}>
                            დოკუმენტის დამატება
                        </Button>
                    </ConfigProvider>
                </Col>
                <Col span={24}>
                    <Table
                        rowClassName={(record) => record.is_active ? 'active-row' : 'inactive-row'}
                        dataSource={docs}
                        columns={columns}
                        rowKey={record => record.id}
                        size="small"
                        pagination={{
                            defaultPageSize: limit,
                            total: docs[0]?.full_count,
                            showSizeChanger: true,
                            showTotal: t => `სულ ${t}`,
                            pageSizeOptions: [12, 24, 48, 72, 96, 120],
                            current: page,
                            onChange: (page, limit) => setFilterParams({ ...filterParams, page, limit })
                        }}
                        scroll={{
                            x: 1000
                        }}
                        style={{ boxShadow: '1px 2px 9px gray', borderRadius: 13, padding: 5 }}
                    />
                </Col>
            </Row>
            {
                open && <DocumentUploadModal open={open} close={setOpen} departments={departments} hierarchies={hierarchies} messageApi={messageApi} />
            }
            {
                docEditModalOpen && <DocumentUploadModal departments={departments} hierarchies={hierarchies} open={docEditModalOpen} close={setDocEditModalOpen} doc={docToEdit} setDocToEdit={setDocToEdit} messageApi={messageApi} />
            }
            {
                docDeactivateModalOpen && <DocumentDeactivationModal open={docDeactivateModalOpen} close={setDocDeactivateModalOpen} doc={docToEdit} setDocToEdit={setDocToEdit} messageApi={messageApi} />
            }
            {
                docReplaceModalOpen && <DocReplaceModal open={docReplaceModalOpen} close={setDocReplaceModalOpen} doc={docToEdit} setDocToEdit={setDocToEdit} messageApi={messageApi} />
            }

            </Card>
        </div>
    )
}